module.exports = __webpack_public_path__ + "assets/img/game-bg.dab27484.png";